import { Drawer as AntdDrawer } from 'antd'
import React from 'react'
import styled from 'styled-components'

const StyledDrawer = styled(AntdDrawer)`
  .ant-drawer-body {
    padding: ${props => (props.padding ? props.padding : '30px')};
  }
  .ant-drawer-wrapper-body {
    height: 100%;
    overflow: auto;
  }
  .ant-drawer-header-title {
    flex-direction: ${props =>
      props.closeIconPosition == 'right' ? 'row-reverse' : 'row'};
  }
`

const DrawerView = ({
  width = '40%',
  title,
  placement,
  closable = false,
  onClose,
  visible,
  content,

  footerStyles,
  closeIconPosition = 'right',
  padding,
  ...rest
}) => {
  return (
    <StyledDrawer
      {...rest}
      width={width}
      title={title}
      placement={placement}
      closable={closable}
      onClose={onClose}
      visible={visible}
      key={placement}
      closeIconPosition={closeIconPosition}
      padding={padding}
    >
      {content}
      {}
    </StyledDrawer>
  )
}
export default DrawerView
